/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

if (typeof ReadyMore !== "function") {
  class ReadyMore extends HTMLElement {
    constructor() {
      super();

      this.readMore = this.querySelector('.read_more_button')
      this.readLess = this.querySelector('.read_less_button')

      this.readMore.addEventListener('click', () => this.toggle(true))
      this.readLess.addEventListener('click', () => this.toggle(false))
      this.style.setProperty('--line-height', this.currentStyle ? this.currentStyle["line-height"] : window.getComputedStyle ? document.defaultView.getComputedStyle(this, null).getPropertyValue('line-height') : '1.3em')
    }
    toggle(bool = false) {
      this.classList.toggle('expend', bool)
    }
  }
  customElements.define('ready-more', ReadyMore);
}

const typingPlaceholders = document.querySelectorAll('.typing_placeholder')
function printStringWithDelay(el, prefix, delay, interval, string, callback) {
  let index = 0;
  const printInterval = setInterval(() => {
    el.placeholder += string[index++];
    if (index === string.length) {
      clearInterval(printInterval);
      setTimeout(() => removeStringWithDelay(el, prefix, delay, interval, string, callback), interval);
    }
  }, delay);
}

function removeStringWithDelay(el, prefix, delay, interval, string, callback) {
  let index = string.length;
  const removeInterval = setInterval(() => {
    el.placeholder = el.placeholder.slice(0, -1);
    if (--index === 0) {
      clearInterval(removeInterval);
      el.placeholder = prefix;
      callback();
    }
  }, delay);
}

function loopArray(el, array, prefix, delay, interval) {
  let index = 0;
  function next() {
    printStringWithDelay(el, prefix, delay, interval, array[index], () => {
      index = (index + 1) % array.length;
      next();
    });
  }
  next();
}

Array.from(typingPlaceholders).forEach(typingPlaceholder => {
  const options = typingPlaceholder.dataset.options.split(',')
  const prefix = typingPlaceholder.dataset.prefix || ""
  const delay = parseInt(typingPlaceholder.dataset.delay || 250)
  const interval = parseInt(typingPlaceholder.dataset.interval || 500)

  typingPlaceholder.placeholder = prefix;
  loopArray(typingPlaceholder, options, prefix, delay, interval)
})


const links = document.links
Array.from(links).forEach(link => {
  if (link.hostname !== window.location.hostname) {
    link.target = "_blank"
    link.rel = "noreferrer noopener"
  }
})
